export const toAttributeString = (questions: Backend.Questionnaire.IQuestion[]) => questions.map(q => q.att).join(', ')

export const hasMalformedDefault = (question: Backend.Questionnaire.IQuestion) => {
    const defaultValue = question.opts.default
    if(!defaultValue) return false
    const defaultHasSeparator = defaultValue.includes(question.opts.defaultSeparator!)
    if(!defaultHasSeparator) return false
    const defaultOptions = defaultValue.split(question.opts.defaultSeparator!)
    return defaultOptions.some(option => !question.opts.selectOptions?.some(o => o.value === option))
  }